module.exports = __webpack_public_path__ + "static/media/da-contact-2.e000a9eb.jpg";